import { CategoriesResponse, FlatCategory, Sticker } from '@shopby/shop-sdk'
import { MouseEvent, useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { Link, useNavigate } from 'react-router-dom'
import { getProductDetail, postLikeProducts } from '../../api/product'
import { addToWishlist } from '../../js/pixelEvent'
import { AFWebLinkType, RNPostMessage, sendSetAppsflyerEvent } from '../../js/postMessage'
import { findObjectsWithValue, formatNumberWithTruncation, onErrorImg, plusComma } from '../../js/script'
import { imgURL } from '../Footer'
import { useAppContext } from '../provider/AppProvider'
import { useCommonContext } from '../provider/CommonProvider'
import { useMyContext } from '../provider/MyProvider'
import { IconStarOn } from '../svg/IconSvg'

type PropsTypes = {
  el: any
  setLike: React.Dispatch<React.SetStateAction<boolean>>
  listId: string
  listName: string
  category: CategoriesResponse | null
  idx: number
  label?: string | null
  priceData: any
}

export function CartItem({ el, setLike, label, priceData, idx, category, listId, listName }: PropsTypes) {
  const [product, setProduct] = useState<any>()
  const [wish, setWish] = useState<boolean>(false)
  const [disCountAcc, setDisCountAcc] = useState<number>(0)
  const [image, setImage] = useState<Sticker[]>([])
  const [text, setText] = useState<Sticker[]>([])
  const [categoryNo, setCategoryNo] = useState<string[]>([])
  const [itemCategory, setItemCategory] = useState<FlatCategory[]>([])
  const [categorys, setCategorys] = useState<FlatCategory[]>([])
  const [change, setChange] = useState<boolean>(false)
  const navigate = useNavigate()
  const { isAppView } = useAppContext()
  const { setToastMessage, setToastBtnMessage, setToastEvent, setIsToast } = useMyContext()
  const { setIsLogin, hasAccessToken } = useCommonContext()

  useEffect(() => {
    setImage([])
    setText([])
  }, [el])

  useEffect(() => {
    if (label === '최근 구매한 상품 모듈') {
      if (product) {
        setWish(product.liked)
      }
    }
  }, [label, product])

  useEffect(() => {
    if (el) {
      el.stickerInfos?.map((element: any) => {
        if (element.type === 'IMAGE') {
          setImage((prev: any) => [...prev, element])
        } else {
          if (text.length === 0) {
            setText((prev: any) => [...prev, element])
          }
        }
      })
    }
  }, [el])

  useEffect(() => {
    setCategoryNo(el.displayCategoryNos?.split('|'))
  }, [el])

  useEffect(() => {
    if (categoryNo && category) {
      categoryNo.map((el: any) => {
        setItemCategory((prev: any) => [...prev, ...findObjectsWithValue(category?.flatCategories, Number(el))])
      })
    }
  }, [categoryNo, category])

  useEffect(() => {
    if (itemCategory) {
      itemCategory.map((el: any) => {
        if (el.depth1Label !== '브랜드') {
          setCategorys((prev: any) => [...prev, el])
        }
      })
    }
  }, [itemCategory])

  useEffect(() => {
    if (el) {
      let count
      if (priceData.length !== 0) {
        count = formatNumberWithTruncation(
          (priceData[idx]?.price?.salePrice - priceData[idx]?.price?.immediateDiscountAmt) * 0.1
        )
      } else {
        count = formatNumberWithTruncation((product?.price?.salePrice - product?.price?.immediateDiscountAmt) * 0.1)
      }
      setDisCountAcc(Number(count.replaceAll(',', '')))
    }
  }, [el, product, priceData, idx])

  useEffect(() => {
    if (label !== '최근 구매한 상품 모듈') {
      setWish(el.liked)
    }
  }, [el])

  useEffect(() => {
    if (!el || !el.productNo) return
    getProductDetail(el.productNo)
      .then((res) => {
        setProduct(res.data)
      })
      .catch((err) => console.log(err))
  }, [el.productNo])

  useEffect(() => {
    if (label === '최근 구매한 상품 모듈' && el.productNo)
      getProductDetail(el.productNo)
        .then((res) => {
          setProduct(res.data)
        })
        .catch((err) => console.log(err))
  }, [change])

  return (
    <li>
      <div className='item_wrap'>
        <div className='item_img'>
          {el?.isSoldOut && (
            <div className='soldout'>
              <img src={`${imgURL}/img_soldout.png`} alt='' />
            </div>
          )}
          <button
            onClick={(): void => {
              if (hasAccessToken) {
                let likeItem: { like: string; productNo: string } = {
                  like: '',
                  productNo: '',
                }
                if (wish) {
                  likeItem = { like: 'N', productNo: el.productNo }
                } else {
                  likeItem = { like: 'Y', productNo: el.productNo }
                }

                postLikeProducts(likeItem)
                  .then((res: any) => {
                    if (res.data.length !== 0) {
                      if (res.data[0].like === 'Y') {
                        setIsToast(true)
                        setToastMessage('찜 리스트에 저장되었습니다.')
                        setToastBtnMessage('바로가기')
                        setToastEvent(() => () => {
                          if (isAppView) {
                            RNPostMessage(AFWebLinkType.moveToLink, {
                              url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/wishList`,
                            })
                          } else {
                            navigate('/wishList')
                          }
                        })
                        addToWishlist(el.productNo, el.productName, el.salePrice, el.immediateDiscountAmt)
                        const array: any = []
                        const obj = {
                          item_id: String(el?.productNo),
                          item_name: el?.productName,
                          affiliation: '어바웃피싱',
                          item_list_price: el?.salePrice,
                          item_selling_price: el?.salePrice - el?.immediateDiscountAmt,
                          price: el?.salePrice - el?.immediateDiscountAmt,
                          item_total_discount: el?.immediateDiscountAmt,
                          discount: 0,
                          index: idx,
                          item_brand: el?.brandName,
                          item_category: categorys[0]?.depth1Label,
                          item_category2: categorys[0]?.depth2Label,
                          item_category3: categorys[0]?.depth3Label,
                          item_list_id: String(listId),
                          item_list_name: listName,
                        }

                        array.push(obj)
                        const gtmWishItem: DataLayerArgs = {
                          dataLayer: {
                            event: 'add_to_wishlist', // ecommerce 이벤트 중 상품보기 단계
                            ecommerce: {
                              value: el?.salePrice - el?.immediateDiscountAmt,
                              items: array,
                            },
                          },
                        }
                        if (isAppView) {
                          sendSetAppsflyerEvent({
                            eventName: 'add_to_wishlist',
                            eventType: {
                              value: el?.salePrice - el?.immediateDiscountAmt,
                              items: array,
                            },
                          })
                        } else {
                          TagManager.dataLayer(gtmWishItem)
                        }
                      } else if (res.data[0].like === 'N') {
                        setIsToast(true)
                        setToastMessage('찜 리스트에 제외되었습니다.')
                        setToastBtnMessage('바로가기')
                        setToastEvent(() => () => {
                          if (isAppView) {
                            RNPostMessage(AFWebLinkType.moveToLink, {
                              url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/wishList`,
                            })
                          } else {
                            navigate('/wishList')
                          }
                        })
                      }
                      setLike((prev: boolean) => !prev)
                      setChange((prev: boolean) => !prev)
                    }
                  })
                  .catch((err) => console.log(err))
              } else {
                if (!hasAccessToken) {
                  setIsToast(true)
                  setToastMessage('로그인이 필요한 서비스입니다.')
                  setToastBtnMessage('로그인')
                  setToastEvent(() => () => {
                    setIsLogin(true)
                  })
                }
              }
            }}
          >
            <img
              src={`${wish ? `${imgURL}/icon_heart_fill.png` : `${imgURL}/icon_heart_outline.png`}`}
              alt='찜하기 아이콘'
            />
          </button>
          {/* <div className='item_flag'>
            {el.label && <img src={el.label} alt='' />}
          </div> */}
          {image.map((element: any, i: number) => {
            return (
              <div className='item_flag' key={`${element?.label}-${i}`}>
                <img src={element?.label} alt='' />
              </div>
            )
          })}
          <div
            // to={`/product/${el.productNo}`}
            onClick={(e): void => {
              e.preventDefault()
              const array: any = []
              const obj: {
                item_id: any
                item_name: any
                affiliation: string
                item_list_price: any
                item_selling_price: number
                price: number
                item_total_discount: any
                discount: number
                index: any
                item_brand: any
                item_category: any
                item_category2: any
                item_category3: any
                item_list_id: any
                item_list_name: any
              } = {
                item_id: String(el?.productNo),
                item_name: el?.productName,
                affiliation: '어바웃피싱',
                item_list_price: el?.salePrice,
                item_selling_price: el?.salePrice - el?.immediateDiscountAmt,
                price: el?.salePrice - el?.immediateDiscountAmt,
                item_total_discount: el?.immediateDiscountAmt,
                discount: 0,
                index: idx,
                item_brand: el?.brandName,
                item_category: categorys[0]?.depth1Label,
                item_category2: categorys[0]?.depth2Label,
                item_category3: categorys[0]?.depth3Label,
                item_list_id: String(listId),
                item_list_name: listName,
              }
              array.push(obj)
              const gtmClickItem: DataLayerArgs = {
                dataLayer: {
                  event: 'select_item', // ecommerce 이벤트 중 상품보기 단계
                  ecommerce: {
                    items: array,
                  },
                },
              }
              if (isAppView) {
                sendSetAppsflyerEvent({
                  eventName: 'select_item',
                  eventType: {
                    items: array,
                  },
                })
              } else {
                TagManager.dataLayer(gtmClickItem)
              }

              if (isAppView) {
                RNPostMessage(AFWebLinkType.moveToLink, {
                  url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${
                    el.productNo
                  }?items=${JSON.stringify(array)}`,
                })
              } else {
                navigate(`/product/${el.productNo}`, {
                  state: { items: array },
                })
              }
            }}
          >
            <div className='dim'></div>
            {hasAccessToken ? (
              <img
                src={
                  label === '장바구니에 담긴 상품 모듈' ||
                  label === '최근 구매한 상품 모듈' ||
                  label === '최근 본 상품 기반 카테고리 내 다른 상품 모듈'
                    ? el?.imageUrl
                    : el?.imageUrls && el?.imageUrls[0]
                }
                alt=''
                onError={onErrorImg}
              />
            ) : (
              <img src={el.imageUrls?.[0]} alt='' onError={onErrorImg} />
            )}
          </div>
        </div>
        <div
          onClick={(e): void => {
            e.preventDefault()
            const array: any = []
            const obj: {
              item_id: any
              item_name: any
              affiliation: string
              item_list_price: any
              item_selling_price: number
              price: number
              item_total_discount: any
              discount: number
              index: any
              item_brand: any
              item_category: any
              item_category2: any
              item_category3: any
              item_list_id: any
              item_list_name: any
            } = {
              item_id: String(el?.productNo),
              item_name: el?.productName,
              affiliation: '어바웃피싱',
              item_list_price: el?.salePrice,
              item_selling_price: el?.salePrice - el?.immediateDiscountAmt,
              price: el?.salePrice - el?.immediateDiscountAmt,
              item_total_discount: el?.immediateDiscountAmt,
              discount: 0,
              index: idx,
              item_brand: el?.brandName,
              item_category: categorys[0]?.depth1Label,
              item_category2: categorys[0]?.depth2Label,
              item_category3: categorys[0]?.depth3Label,
              item_list_id: String(listId),
              item_list_name: listName,
            }
            array.push(obj)
            const gtmClickItem: DataLayerArgs = {
              dataLayer: {
                event: 'select_item', // ecommerce 이벤트 중 상품보기 단계
                ecommerce: {
                  items: array,
                },
              },
            }
            if (isAppView) {
              sendSetAppsflyerEvent({
                eventName: 'select_item',
                eventType: {
                  items: array,
                },
              })
            } else {
              TagManager.dataLayer(gtmClickItem)
            }
            // setPrevScroll(document.documentElement.scrollTop);
            if (isAppView) {
              RNPostMessage(AFWebLinkType.moveToLink, {
                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${
                  el.productNo
                }?items=${JSON.stringify(array)}`,
              })
            } else {
              navigate(`/product/${el.productNo}`, {
                state: { items: array },
              })
            }
          }}
        >
          {el.brandName && <div className='item_brand_title'>{el.brandName}</div>}
          <div className='item_title'>{el?.productName}</div>

          {Math.floor((product?.price?.immediateDiscountAmt / product?.price?.salePrice) * 100) === 0 ? (
            <>
              <div className='item_sale_wrap'>
                <p className='price'>{plusComma(product?.price?.salePrice - product?.price?.immediateDiscountAmt)}원</p>
              </div>
            </>
          ) : (
            <>
              <div className='item_origin_price'>{plusComma(product?.price?.salePrice)}원</div>
              <div className='item_sale_wrap'>
                <p className='percent'>
                  {Math.floor((product?.price?.immediateDiscountAmt / product?.price?.salePrice) * 100)}%
                </p>
                <p className='price'>{plusComma(product?.price?.salePrice - product?.price?.immediateDiscountAmt)}원</p>
              </div>
            </>
          )}
          {label === '장바구니에 담긴 상품 모듈' ? (
            !el.accumulationUsable && !el.couponUsable ? null : (
              <div className='item_maximum_benefit'>
                <p className='badge'>회원혜택가</p>
                {product && product?.price ? (
                  product?.price.salePrice -
                    product?.price.immediateDiscountAmt -
                    product?.price.couponDiscountAmt -
                    (product?.price?.accumulationAmtWhenBuyConfirm !== 0
                      ? product?.price?.accumulationAmtWhenBuyConfirm
                      : 0) -
                    (el?.accumulationUsable ? Number(disCountAcc) : 0) ===
                  Number(product?.price.salePrice - product?.price.immediateDiscountAmt) ? null : (
                    <p>
                      {plusComma(
                        Math.ceil(
                          product?.price.salePrice -
                            product?.price.immediateDiscountAmt -
                            product?.price.couponDiscountAmt -
                            (product?.price?.accumulationAmtWhenBuyConfirm !== 0
                              ? product?.price?.accumulationAmtWhenBuyConfirm
                              : 0) -
                            (el?.accumulationUsable ? Number(disCountAcc) : 0)
                        )
                      )}
                      원
                    </p>
                  )
                ) : (
                  <p>0원</p> // 로딩 중 혹은 기본값 표시
                )}
              </div>
            )
          ) : label === '최근 구매한 상품 모듈' ? (
            <div className='item_maximum_benefit'>
              <p className='badge'>회원혜택가</p>
              {product && product.price ? (
                product?.price.salePrice -
                  product?.price.immediateDiscountAmt -
                  product?.price.couponDiscountAmt -
                  (product?.price?.accumulationAmtWhenBuyConfirm !== 0
                    ? product?.price?.accumulationAmtWhenBuyConfirm
                    : 0) -
                  (product?.baseInfo?.accumulationUseYn !== 'N' ? Number(disCountAcc) : 0) ===
                Number(product?.price.salePrice - product?.price.immediateDiscountAmt) ? null : (
                  <p>
                    {plusComma(
                      Math.ceil(
                        product?.price.salePrice -
                          product?.price.immediateDiscountAmt -
                          product?.price.couponDiscountAmt -
                          (product?.price?.accumulationAmtWhenBuyConfirm !== 0
                            ? product?.price?.accumulationAmtWhenBuyConfirm
                            : 0) -
                          (product?.baseInfo?.accumulationUseYn !== 'N' ? Number(disCountAcc) : 0)
                      )
                    )}
                    원
                  </p>
                )
              ) : (
                <p>0원</p> // 로딩 중 혹은 기본값 표시
              )}
            </div>
          ) : product?.baseInfo?.accumulationUseYn === 'N' && product.baseInfo.couponUseYn === 'N' ? null : product
              ?.price.salePrice -
              product?.price?.immediateDiscountAmt -
              product?.price?.couponDiscountAmt -
              (product?.price?.accumulationAmtWhenBuyConfirm !== 0
                ? product?.price?.accumulationAmtWhenBuyConfirm
                : 0) -
              (product?.baseInfo?.accumulationUseYn === 'Y' ? Number(disCountAcc) : 0) ===
            Number(product?.price.salePrice - product?.price?.immediateDiscountAmt) ? null : (
            <div className='item_maximum_benefit'>
              <p className='badge'>회원혜택가</p>
              {product && product?.price ? (
                <p>
                  {plusComma(
                    Math.ceil(
                      product?.price.salePrice -
                        product?.price.immediateDiscountAmt -
                        product?.price.couponDiscountAmt -
                        (product?.price?.accumulationAmtWhenBuyConfirm !== 0
                          ? product.price?.accumulationAmtWhenBuyConfirm
                          : 0) -
                        (product?.baseInfo?.accumulationUseYn === 'Y' ? Number(disCountAcc) : 0)
                    )
                  )}
                  원
                </p>
              ) : (
                <p>0원</p> // 로딩 중 혹은 기본값 표시
              )}
            </div>
          )}

          {/* 페이백 적립금 5% + 추가적립금 */}
          {hasAccessToken &&
            (product?.price?.accumulationAmtWhenBuyConfirm === 0 ? null : (
              <div className='save_mileage'>
                <p>
                  {`페이백 적립금 ${product?.price.accumulationRate}% `}
                  {plusComma(product?.price?.accumulationAmtWhenBuyConfirm)}
                  <span>
                    <img src={`${imgURL}/icon_point.png`} alt='' />
                  </span>
                </p>
              </div>
            ))}

          <div className='item_star_rating'>
            <IconStarOn width={isMobile ? 14 : 16} height={isMobile ? 14 : 16} />
            <span className='review_rating'>{!product ? priceData[idx]?.reviewRate : product?.reviewRate}</span>
            <span className='review_num'>
              ({!product ? priceData[idx]?.counter.likeCnt : product?.counter?.reviewCnt})
            </span>

            {/* Npay */}
            <div className='npay'>
              <img src={`${imgURL}/icon_npay.png`} alt='Naver Pay' />
            </div>
          </div>
          {/* flag 없으면 보이지 않게 함 */}
          {text.length !== 0 && (
            <div className='item_txt_flag'>
              {text.map((el: any, i: number) => {
                return (
                  <span className='delivery' key={`${el?.label}-${i}`}>
                    {el?.label}
                  </span>
                )
              })}
            </div>
          )}
        </div>
      </div>
    </li>
  )
}
